import { useState } from "react";

// Moving before/after evidence strip — LP2 paid-ads landing pages only.
// Client-supplied branded field composites (BEFORE above / AFTER below), one
// set per service. Seamless right-to-left CSS marquee on the site's shared
// rail system. Pauses on cursor hover (desktop), finger press (mobile) and
// keyboard focus. prefers-reduced-motion: animation off, cards wrap statically
// (handled by the shared .rail reduced-motion rules).
const GALLERIES = {
  "kitchen-exhaust": {
    label: "Kitchen exhaust duct cleaning",
    count: 6,
    src: (n) => `/assets/dcc/lp2-ba-${n}.webp`,
  },
  "air-duct": {
    label: "Robotic air duct cleaning",
    count: 6,
    src: (n) => `/assets/dcc/lp2-air-ba-${n}.webp`,
  },
};

export function EvidenceMarquee({ serviceId = "kitchen-exhaust" }) {
  const [held, setHeld] = useState(false);
  const g = GALLERIES[serviceId] || GALLERIES["kitchen-exhaust"];
  const items = Array.from({ length: g.count }, (_, i) => ({
    src: g.src(i + 1),
    alt: `${g.label} before and after — DCC field documentation, set ${i + 1} of ${g.count}`,
  }));
  return (
    <div
      className={`rail rail-mask ${held ? "rail-held" : ""}`}
      data-testid="evidence-marquee"
      role="region"
      aria-label={`Before and after ${g.label.toLowerCase()} evidence gallery — moving strip, hold to pause`}
      onTouchStart={() => setHeld(true)}
      onTouchEnd={() => setHeld(false)}
      onTouchCancel={() => setHeld(false)}
    >
      <div className="rail-track animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="rail-copy gap-4 pr-4" aria-hidden={copy === 1 || undefined}>
            {items.map((it, i) => (
              <figure
                key={it.src}
                className="w-[240px] shrink-0 sm:w-[300px]"
                data-testid={copy === 0 ? `evidence-marquee-item-${i + 1}` : undefined}
              >
                <img
                  src={it.src}
                  alt={copy === 0 ? it.alt : ""}
                  width="720"
                  height="900"
                  loading="lazy"
                  decoding="async"
                  className="w-full border border-zinc-800"
                />
              </figure>
            ))}
          </div>
        ))}
      </div>
      <p className="mt-4 font-mono text-xs leading-relaxed text-zinc-400">
        // DCC field documentation — camera-inspection photography from live client systems. Hold or hover to pause.
      </p>
    </div>
  );
}
